import app, { Component } from 'apprun';
import { regions } from '../api';
import RegionSelect from '../common-props/common-props-regions-select';
interface IDictionary {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [index: string]: any;
}

export default class CommonPropertyComponent extends Component {
  AllRegions: IDictionary = {};

  getMatchingOptions = async (searchText) => {
    this.AllRegions = [];

    const matchingRegions = await regions.getRegions(searchText, this.state.extra.province);
    const options = [];

    matchingRegions.map((p) =>{
      this.AllRegions[p.regionsServicedID] = p;
      options.push({ value: p.regionsServicedName, id: p.regionsServicedID });
    });

    this.state.options = options;

    return options.map(p => p.value);
  };

  onSearch = async (searchText) => {
    const errDiv = document.getElementById(this.state.item.fieldName + 'ErrMsg') as HTMLDivElement;
    if (errDiv) {errDiv.innerHTML = '';}

    let options;
    if (searchText.length >= 3) {
      options = await this.getMatchingOptions(searchText);
    }else{
      options = [];
    }
    return options;
  };

  onSelect = () => {
    return;
  };

  view = (state) => {
    if (!state || !state.newVal) {return;}
    return (
      <div style={{ width: '400px' }}>
        <table>
          {state.newVal.map(p => (
            <tr>
              <td>
                {p.regionsServicedName}&nbsp;
                <a class="btn btn-xs" onclick={() => this.run('delArea', p)}>
                  ✂
                </a>
              </td>
            </tr>
          ))}
        </table>
        <div>
          <div class="col-sm-6">
            <RegionSelect
              onSearch={this.onSearch}
              onSelect={this.onSelect}
              id={state.item.fieldName}
            />
            <div id={state.item.fieldName + 'ErrMsg'} class="text-danger"></div>
          </div>
          &nbsp;
          <a type="button" class="btn btn-primary" onclick={() => this.run('addArea')}>
            add
          </a>
        </div>
        <br />
        <div class="edit-buttons">
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('save')}>
            save
          </a>
          <a type="button" class="btn btn-default btn-xs" onclick={() => state.caller.run(state.cancel, state.panelId)}>
            cancel
          </a>
        </div>
      </div>
    );
  };

  update = {
    refresh: (state, newState) => {
      return { ...state, ...newState,  newVal: [...newState.item.value], options: [], selected: '' };
    },

    save: (state) => {
      if (!state.newVal) {return;}
      //state.item.value = state.newVal;
      state.caller.run(state.save, state.item, state.panelId, state.newVal);
    },

    delArea: (state, p) => {
      //console.log('In delArea...');
      state.newVal.splice(state.newVal.indexOf(p), 1);
      return state;
    },

    addArea: (state) => {
      const inpText = document.getElementById(state.item.fieldName + '_inpText') as HTMLInputElement;
      const newRegion = state.options.find(p => p.value.toUpperCase() === inpText.value.toUpperCase());
      //console.log(newRegion);
      if (newRegion) {
        state.newVal.push(this.AllRegions[newRegion.id]);
        return state;
      } else {
        const errDiv = document.getElementById(state.item.fieldName + 'ErrMsg') as HTMLDivElement;
        errDiv.innerHTML = 'Invalid Value';
      }
    }
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
